import { useNavigate } from "react-router-dom";

export default function CourseCard({ course, compact = false }) {
  const navigate = useNavigate();
  const discount = course.mrp > course.price
    ? Math.round(((course.mrp - course.price) / course.mrp) * 100)
    : 0;

  return (
    <div
      data-testid={`course-card-${course.id}`}
      onClick={() => navigate(`/courses/${course.id}`)}
      className={`bg-white cursor-pointer flex-shrink-0 ${compact ? "w-64" : "w-full"}`}
    >
      <div className="aspect-video w-full bg-slate-200 overflow-hidden relative">
        <img
          src={course.image_url || "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&h=338&fit=crop"}
          alt={course.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="p-3">
        <p className="text-xs font-bold uppercase tracking-wider text-[#0284C7] mb-1">
          {course.category || "General"}
        </p>
        <h3 className="font-bold text-sm text-slate-900 leading-snug mb-2 line-clamp-2">
          {course.title}
        </h3>
        <div className="flex items-center gap-2">
          <span className="font-black text-base text-slate-900">
            &#8377;{course.price}
          </span>
          {course.mrp > course.price && (
            <>
              <span className="text-xs text-slate-400 line-through">&#8377;{course.mrp}</span>
              <span className="bg-green-600 text-white text-[10px] font-bold px-1.5 py-0.5">
                {discount}% OFF
              </span>
            </>
          )}
        </div>
        <span className="text-[10px] font-medium text-slate-500 uppercase mt-1 inline-block">
          {course.content_type === "book" ? "Book / PDF" : "Video Course"}
        </span>
      </div>
    </div>
  );
}
